import { render, staticRenderFns } from "./CleanForm.vue?vue&type=template&id=b8945542&"
import script from "./CleanForm.vue?vue&type=script&lang=js&"
export * from "./CleanForm.vue?vue&type=script&lang=js&"
import style0 from "./CleanForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VScaleTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VForm,VRow,VScaleTransition})
